import React, { Component } from 'react'
import {BrowserRouter as Router} from 'react-router-dom'
import {Provider} from 'react-redux'
import {initStore} from './actions/'
import { injectGlobal } from 'styled-components'
import Routes from './routes'
import Api from './lib/api'

import 'react-select/dist/react-select.css';

injectGlobal`
    body,html{
        min-height:100%;
        width:100%;

    }
   
    *{
        font-family: 'Barlow', sans-serif;
        margin: 0;
        padding: 0;
        box-sizing:border-box;
    }
    a{
      
    }
`
console.log('init api', process.env.REACT_APP_API_URL, '0.9.5')
Api.init({
    publicBase: process.env.REACT_APP_PUBLIC_URL || 'http://localhost:8080/',
    base: process.env.REACT_APP_API_URL || 'http://localhost:8080/api/v1/'    
})

const store = initStore()

class App extends Component {
    render() {
        return (
            <Provider store={store}>
                <Router>
                    <Routes store={store} />
                </Router>
            </Provider>
        )
    }
}

export default App



// WEBPACK FOOTER //
// ./src/app.js